/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSegmentRequest } from '../../models/create-segment-request';
import { Segment } from '../../models/segment';

export interface BulkCreateSegment$Params {
      body: Array<CreateSegmentRequest>
}

export function bulkCreateSegment(http: HttpClient, rootUrl: string, params: BulkCreateSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Segment>>> {
  const rb = new RequestBuilder(rootUrl, bulkCreateSegment.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Segment>>;
    })
  );
}

bulkCreateSegment.PATH = '/v0/segments/bulk';
